/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { BlockConfigAreaRequest } from '../model'
// @ts-ignore
import type { BlockConfigAreaResponse } from '../model'
// @ts-ignore
import type { DeleteConfigAreaRequest } from '../model'
// @ts-ignore
import type { IsSlotBlockedResponse } from '../model'
// @ts-ignore
import type { LimitStackHeightConfigAreaRequest } from '../model'
// @ts-ignore
import type { LimitStackHeightConfigAreaResponse } from '../model'
// @ts-ignore
import type { ReeferPlugConfigAreaRequest } from '../model'
// @ts-ignore
import type { ReeferPlugConfigAreaResponse } from '../model'
// @ts-ignore
import type { SpaceBetweenBaysConfigAreaRequest } from '../model'
// @ts-ignore
import type { SpaceBetweenBaysConfigAreaResponse } from '../model'
/**
 * YardConfigsApi - axios parameter creator
 */
export const YardConfigsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {BlockConfigAreaRequest} [blockConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockConfigArea: async (
      blockConfigAreaRequest?: BlockConfigAreaRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardConfigs/BlockConfigArea`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        blockConfigAreaRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteConfigAreaRequest} [deleteConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteYardConfigArea: async (
      deleteConfigAreaRequest?: DeleteConfigAreaRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardConfigs`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteConfigAreaRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [blockId]
     * @param {number} [row]
     * @param {number} [bay]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isSlotBlocked: async (
      blockId?: string,
      row?: number,
      bay?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardConfigs/IsSlotBlocked`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (blockId !== undefined) {
        localVarQueryParameter['BlockId'] = blockId
      }

      if (row !== undefined) {
        localVarQueryParameter['Row'] = row
      }

      if (bay !== undefined) {
        localVarQueryParameter['Bay'] = bay
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {LimitStackHeightConfigAreaRequest} [limitStackHeightConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    limitStackHeightConfigArea: async (
      limitStackHeightConfigAreaRequest?: LimitStackHeightConfigAreaRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardConfigs/LimitStackHeightConfigArea`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        limitStackHeightConfigAreaRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {ReeferPlugConfigAreaRequest} [reeferPlugConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reeferPlugConfigArea: async (
      reeferPlugConfigAreaRequest?: ReeferPlugConfigAreaRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardConfigs/ReeferPlugConfigArea`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        reeferPlugConfigAreaRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {SpaceBetweenBaysConfigAreaRequest} [spaceBetweenBaysConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceBetweenBaysConfigArea: async (
      spaceBetweenBaysConfigAreaRequest?: SpaceBetweenBaysConfigAreaRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/YardConfigs/SpaceBetweenBaysConfigArea`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        spaceBetweenBaysConfigAreaRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * YardConfigsApi - functional programming interface
 */
export const YardConfigsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = YardConfigsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {BlockConfigAreaRequest} [blockConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async blockConfigArea(
      blockConfigAreaRequest?: BlockConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockConfigAreaResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.blockConfigArea(
        blockConfigAreaRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardConfigsApi.blockConfigArea']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteConfigAreaRequest} [deleteConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteYardConfigArea(
      deleteConfigAreaRequest?: DeleteConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteYardConfigArea(
        deleteConfigAreaRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardConfigsApi.deleteYardConfigArea']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [blockId]
     * @param {number} [row]
     * @param {number} [bay]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async isSlotBlocked(
      blockId?: string,
      row?: number,
      bay?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsSlotBlockedResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.isSlotBlocked(
        blockId,
        row,
        bay,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardConfigsApi.isSlotBlocked']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {LimitStackHeightConfigAreaRequest} [limitStackHeightConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async limitStackHeightConfigArea(
      limitStackHeightConfigAreaRequest?: LimitStackHeightConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LimitStackHeightConfigAreaResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.limitStackHeightConfigArea(
        limitStackHeightConfigAreaRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardConfigsApi.limitStackHeightConfigArea']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {ReeferPlugConfigAreaRequest} [reeferPlugConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reeferPlugConfigArea(
      reeferPlugConfigAreaRequest?: ReeferPlugConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReeferPlugConfigAreaResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reeferPlugConfigArea(
        reeferPlugConfigAreaRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardConfigsApi.reeferPlugConfigArea']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {SpaceBetweenBaysConfigAreaRequest} [spaceBetweenBaysConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spaceBetweenBaysConfigArea(
      spaceBetweenBaysConfigAreaRequest?: SpaceBetweenBaysConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpaceBetweenBaysConfigAreaResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spaceBetweenBaysConfigArea(
        spaceBetweenBaysConfigAreaRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardConfigsApi.spaceBetweenBaysConfigArea']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * YardConfigsApi - factory interface
 */
export const YardConfigsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = YardConfigsApiFp(configuration)
  return {
    /**
     *
     * @param {BlockConfigAreaRequest} [blockConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockConfigArea(
      blockConfigAreaRequest?: BlockConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<BlockConfigAreaResponse> {
      return localVarFp
        .blockConfigArea(blockConfigAreaRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteConfigAreaRequest} [deleteConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteYardConfigArea(
      deleteConfigAreaRequest?: DeleteConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteYardConfigArea(deleteConfigAreaRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} [blockId]
     * @param {number} [row]
     * @param {number} [bay]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isSlotBlocked(
      blockId?: string,
      row?: number,
      bay?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<IsSlotBlockedResponse> {
      return localVarFp
        .isSlotBlocked(blockId, row, bay, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {LimitStackHeightConfigAreaRequest} [limitStackHeightConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    limitStackHeightConfigArea(
      limitStackHeightConfigAreaRequest?: LimitStackHeightConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LimitStackHeightConfigAreaResponse> {
      return localVarFp
        .limitStackHeightConfigArea(limitStackHeightConfigAreaRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {ReeferPlugConfigAreaRequest} [reeferPlugConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reeferPlugConfigArea(
      reeferPlugConfigAreaRequest?: ReeferPlugConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ReeferPlugConfigAreaResponse> {
      return localVarFp
        .reeferPlugConfigArea(reeferPlugConfigAreaRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {SpaceBetweenBaysConfigAreaRequest} [spaceBetweenBaysConfigAreaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spaceBetweenBaysConfigArea(
      spaceBetweenBaysConfigAreaRequest?: SpaceBetweenBaysConfigAreaRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SpaceBetweenBaysConfigAreaResponse> {
      return localVarFp
        .spaceBetweenBaysConfigArea(spaceBetweenBaysConfigAreaRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * YardConfigsApi - object-oriented interface
 */
export class YardConfigsApi extends BaseAPI {
  /**
   *
   * @param {BlockConfigAreaRequest} [blockConfigAreaRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public blockConfigArea(
    blockConfigAreaRequest?: BlockConfigAreaRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardConfigsApiFp(this.configuration)
      .blockConfigArea(blockConfigAreaRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteConfigAreaRequest} [deleteConfigAreaRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteYardConfigArea(
    deleteConfigAreaRequest?: DeleteConfigAreaRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardConfigsApiFp(this.configuration)
      .deleteYardConfigArea(deleteConfigAreaRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [blockId]
   * @param {number} [row]
   * @param {number} [bay]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public isSlotBlocked(
    blockId?: string,
    row?: number,
    bay?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return YardConfigsApiFp(this.configuration)
      .isSlotBlocked(blockId, row, bay, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {LimitStackHeightConfigAreaRequest} [limitStackHeightConfigAreaRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public limitStackHeightConfigArea(
    limitStackHeightConfigAreaRequest?: LimitStackHeightConfigAreaRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardConfigsApiFp(this.configuration)
      .limitStackHeightConfigArea(limitStackHeightConfigAreaRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {ReeferPlugConfigAreaRequest} [reeferPlugConfigAreaRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public reeferPlugConfigArea(
    reeferPlugConfigAreaRequest?: ReeferPlugConfigAreaRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardConfigsApiFp(this.configuration)
      .reeferPlugConfigArea(reeferPlugConfigAreaRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {SpaceBetweenBaysConfigAreaRequest} [spaceBetweenBaysConfigAreaRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public spaceBetweenBaysConfigArea(
    spaceBetweenBaysConfigAreaRequest?: SpaceBetweenBaysConfigAreaRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return YardConfigsApiFp(this.configuration)
      .spaceBetweenBaysConfigArea(spaceBetweenBaysConfigAreaRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
